import React from "react";
import { Link } from "react-router-dom";

interface CategoryItem {
  image: string;
  title: string;
  link: string;
  alt?: string;
}

interface CategoryProps {
  title?: string;
  items: CategoryItem[];
  className?: string;
}

const Category: React.FC<CategoryProps> = ({
  title,
  items,
  className = "",
}) => {
  return (
    <div className={`w-full pt-[14px] md:pt-10 ${className}`}>
      {title && (
        <div className="mb-6 px-5 ml-[3%]">
          <h2 className="text-2xl font-bold text-center text-gray-800">
            {title}
          </h2>
        </div>
      )}

      <div className="max-w-[1710px] mx-auto px-[20px]">
        <div className="grid grid-cols-1 md:grid-cols-3">
          {items.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className="group block hover:opacity-95 transition-opacity duration-300 pt-5 md:pt-0 md:px-2.5"
            >
              <div className="relative overflow-hidden w-full max-w-[543px] max-h-[269px]">
                <img
                  src={item.image}
                  alt={item.alt || item.title}
                  className="object-cover transition-transform duration-300 w-full h-full"
                  loading="lazy"
                />

                <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Category;
